type KeypadKey = {
  value: string;
  subtext?: string;
};

const keypadKeys: KeypadKey[][] = [
  [
    {
      value: '1',
    },
    {
      value: '2',
      subtext: 'ABC',
    },
    {
      value: '3',
      subtext: 'DEF',
    },
  ],
  [
    {
      value: '4',
      subtext: 'GHI',
    },
    {
      value: '5',
      subtext: 'JKL',
    },
    {
      value: '6',
      subtext: 'MNO',
    },
  ],
  [
    {
      value: '7',
      subtext: 'PQRS',
    },
    {
      value: '8',
      subtext: 'TUV',
    },
    {
      value: '9',
      subtext: 'WXYZ',
    },
  ],
  [
    {
      value: '*',
    },
    {
      value: '0',
      subtext: '+',
    },
    {
      value: '#',
    },
  ],
];

export default keypadKeys;
